import React, { useState, useEffect } from "react";
import { Container, Button, Input, Row, Col, Alert,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody } from 'design-react-kit';
import { getListaVeicoliAttiviUltimiTreAnni, postRichiestaIscrizione, postVerificaIscrizione } from "../../services/endpoints";
import { showProgress } from "../../utils/elements";
import * as Validator from "../../utils/validator"
import * as Constants from '../../utils/constants'
import { isCedutoOltreTreAnniFa } from "../../utils/utilities";

export const SibaTabellaVeicoliAttivi = (props) => {

  const [veicoliAttivi, setVeicoliAttivi] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [esito, setEsito] = useState({});
  const [isLoadingIscrizione, setLoadingIscrizione] = useState(true);
  const [email, setEmail] = useState("");
  //STALIGK-835
  const [newEmail, setNewEmail] = useState("");
  
  const [buttonIscrizioneLabel, setButtonIscrizioneLabel] = useState(Constants.BUTTON_LABEL_ISCRIVITI_AL_SERVIZIO)
  const [isIscritto, setIscritto] = useState(false)
  const [labelAttiva, setLabelAttiva] = useState(Constants.LABEL_ISCRIVITI_AL_SERVIZIO)
  const [mostraEsitoAggiornamentoAvvisi, setMostraEsitoAggiornamentoAvvisi] = useState(false)
  //STALIGK-835
  const [alertGiaIscritto, setAlertGiaIscritto] = useState("");
  
  //const [isModaleVisibile, setModaleVisibile] = useState(false);
  //const modaleClose = () => { setModaleVisibile(false); }
  const [isOpenBase, toggleBaseModal] = useState(false);

  useEffect(() => {
    const loadVeicoliAttivi = async () => {
      let listaVeicoliAttivi = await getListaVeicoliAttiviUltimiTreAnni(props.cf);
      console.log('listaVeicoliAttivi=', listaVeicoliAttivi);
      if (listaVeicoliAttivi === undefined || listaVeicoliAttivi.length === 0) {
        console.log('Lista veicoli attivi è vuota per CF: ', props.cf)
        setLoading(false)
        return
      }
      verificaPresenzaIscrizione();
      setVeicoliAttivi(listaVeicoliAttivi) //array di JSON
      setLoading(false)
    }

    loadVeicoliAttivi();
  }, [])

  const verificaPresenzaIscrizione = async () => {
    setLoadingIscrizione(true)
    const iscrizione = buildRequestBody();
    let esitoVerifica = await postVerificaIscrizione(iscrizione)
    console.log('verificaPresenzaIscrizione esitoVerifica=', esitoVerifica)
    if (esitoVerifica === undefined) {
      setLoadingIscrizione(false)
      return
    }

    if (esitoVerifica && esitoVerifica.isPresente) {
      setShow(esitoVerifica.isPresente)
      setEmail(esitoVerifica.email)
      setButtonIscrizioneLabel(Constants.BUTTON_LABEL_RISULTI_ISCRITTO)
      //STALIGK-835
      setShow(false)
      setAlertGiaIscritto(<Alert className="alert_iscritto" color="info">{Constants.STR_GIA_ISCRITTO_BEFORE} <strong> {esitoVerifica.email} </strong> {Constants.STR_GIA_ISCRITTO_AFTER}</Alert>);
      setIscritto(esitoVerifica.isPresente)
      setLabelAttiva(Constants.LABEL_RIMUOVITI_DAL_SERVIZIO)
      setMostraEsitoAggiornamentoAvvisi(false)
    } else {
      setEsito(esitoVerifica)
      setMostraEsitoAggiornamentoAvvisi(false)
    }
    setLoadingIscrizione(false)
  }


  const handleSubmit = (data) => { props.handleChoice(data) }

  //START RENDERING
  const handleShowEmail = () => { console.log("MM sono qua "); setShow(!show) }

  const showResult = () => { return (esito && esito.status) ? <Alert color="danger" >{esito.title + ' - ' + esito.detail}</Alert> : <Alert color="info" >"Aggiornamento avvenuto con successo"</Alert> }

  const placehIni = "ind. email diverso da: " + (email)

  const showIscrizioneAvvisiScadenza = () => {
    if (!isIscritto) {
      return (show ?
        <Container className="px-2 my-2" id="veicoliAttivi" tag="section">
          <Row>
            <Col>{Constants.AVVISO_SCADENZA_MAIL}</Col>
          </Row>
          <Row><Col>
               <Input type='email' 
                label='Indirizzo email' 
                id='exampleInputEmail' 
                infoText="Inserire l'indirizzo email sul quale volete ricevere gli avvisi di scadenza"
                onChange={handleEmail} 
                value={email} 
                invalid={!Validator.isValidEmail(email)}
                valid={Validator.isValidEmail(email)}
                 />
          </Col></Row>
          <Row><Col><Button className="btn btn-primary" size="xs" color="primary" onClick={handleInviaRichiesta} disabled={!Validator.isValidEmail(email)}> {labelAttiva} </Button></Col></Row>
        </Container> :
        <div></div>)
    } else {
      return (show ?
      <Container className="px-2 my-2" id="veicoliAttivi" tag="section">
        <Row><Col>
             <Input type='email' 
              label='Nuovo indirizzo email' 
              id='exampleInputEmail' 
              infoText="Inserire il nuovo indirizzo email sul quale ricevere gli avvisi di scadenza (deve essere diverso dal precedente)"
              onChange={handleNewEmail} 
              value={newEmail} 
              invalid={!Validator.isValidEmail(newEmail)} 
              valid={Validator.isValidEmail(newEmail)}
              placeholder={(placehIni)}
              /></Col></Row>
        <Row><Col>
          <Button className="btn btn-primary my-2" size="xs" color="primary" onClick={handleInviaRichiestaAggiornamentoEmail} disabled={!Validator.isValidAndDifferentEmail(newEmail,email)} > Salva nuovo indirizzo email </Button>
          &nbsp;
          {/*<Button className="btn btn-danger" size="xs" color="primary" onClick={() =>{ if(window.confirm('Confermi la rimozione dal servizio avvisi di scadenza ?')) handleInviaRichiesta();}} disabled={!Validator.isValidEmail(email)}> {labelAttiva} </Button>*/}
          <Button className="btn btn-danger" size="xs" color="primary" onClick={() => toggleBaseModal(!isOpenBase)} disabled={!Validator.isValidEmail(email)}> {labelAttiva} </Button>
        </Col>
        </Row>
        
        <Modal isOpen={isOpenBase}
          toggle={() => toggleBaseModal(!isOpenBase)}
          popConfirm 
          style={{ maxWidth: "50%" }}>
          <ModalHeader charCode={215} closeAriaLabel="Close" tag="h5" wrapTag="div" >
            SERVIZIO AVVISI DI SCADENZA
          </ModalHeader>
          <ModalBody tag="div">
          Confermi la rimozione dal servizio avvisi di scadenza ? <br/>
          <small>Se confermi cliccando su "OK" per errore, sarà comunque possibile rieffettuare nuovamente l'iscrizione.</small>
          </ModalBody>
          <ModalFooter tag="div">
            <Button
              className="btn btn-outline-primary"
              onClick={handleInviaRichiesta}
            > OK
            </Button>
            <Button
              id="modale_ok"
              className="btn btn-primary"
              color="primary"
              onClick={() => toggleBaseModal(!isOpenBase)}
            > Annulla
            </Button>
          </ModalFooter>
        </Modal>
      
      </Container>
      :
      <div></div>)
    }
  }

  const handleEmail = (event) => {
    setEmail(event.target.value)
  }

  const handleNewEmail = (event) => {
    setNewEmail(event.target.value)
  }

  const buildRequestBody = () => {
    const body = {
      "codiceFiscale": props.cf,
      "email": email,
      "attivazione": isIscritto ? 0 : 1

    }
    return body;
  }
  //STALIGK-835
  const buildRequestNewMailBody = () => {
    const body = {
      "codiceFiscale": props.cf,
      "email": newEmail,
      "attivazione": isIscritto ? 0 : 1

    }
    return body;
  }

  const handleInviaRichiesta = () => {
    const iscrizione = buildRequestBody();
    sendRichiestaIscrizione(iscrizione);
  }

  const handleInviaRichiestaAggiornamentoEmail = () => {
    //const iscrizione = buildRequestBody();
    const iscrizione = buildRequestNewMailBody();
    iscrizione.attivazione = isIscritto ? 1 : 0
    sendRichiestaIscrizioneEmail(iscrizione);
     
  }

  const sendRichiestaIscrizione = async (datiRichiesta) => {
    setLoadingIscrizione(true)
    const esitoIscrizione = await postRichiestaIscrizione(datiRichiesta);
    console.log('sendRichiestaIscrizione esitoIscrizione=', esitoIscrizione)
    if (esitoIscrizione === undefined) {
      setLoadingIscrizione(false)
      return
    }

    if (esitoIscrizione && esitoIscrizione.flag_attivazione !== undefined) {
      setShow(esitoIscrizione.flag_attivazione == 0)
      setEmail(esitoIscrizione.email)
      setIscritto(esitoIscrizione.flag_attivazione == 0)
      if (esitoIscrizione.flag_attivazione == 0) {
        setButtonIscrizioneLabel(Constants.BUTTON_LABEL_RISULTI_ISCRITTO)
        //STALIGK-835
        setShow(false)
        setAlertGiaIscritto(<Alert className="alert_iscritto" color="info">{Constants.STR_GIA_ISCRITTO_BEFORE} <strong> {esitoIscrizione.email} </strong> {Constants.STR_GIA_ISCRITTO_AFTER}</Alert>);
        setLabelAttiva(Constants.LABEL_RIMUOVITI_DAL_SERVIZIO)
        setMostraEsitoAggiornamentoAvvisi(true)
      } else {
        setButtonIscrizioneLabel(Constants.BUTTON_LABEL_ISCRIVITI_AL_SERVIZIO)
        //STALIGK-835
        setAlertGiaIscritto("");
    
        setLabelAttiva(Constants.LABEL_ISCRIVITI_AL_SERVIZIO)
        setEmail('')
        setMostraEsitoAggiornamentoAvvisi(true)
      }
    } else {
      setEsito(esitoIscrizione)
      setMostraEsitoAggiornamentoAvvisi(true)
    }
    setLoadingIscrizione(false)
  }

  const sendRichiestaIscrizioneEmail = async (datiRichiesta) => {
    setLoadingIscrizione(true)
    const esitoIscrizione = await postRichiestaIscrizione(datiRichiesta);
    console.log('sendRichiestaIscrizioneEmail esitoIscrizione=', esitoIscrizione)
    if (esitoIscrizione === undefined) {
      setLoadingIscrizione(false)
      return
    }

    if (esitoIscrizione && esitoIscrizione.flag_attivazione !== undefined) {
      setShow(esitoIscrizione.flag_attivazione == 1)
      setIscritto(esitoIscrizione.flag_attivazione == 1)
      //STALIGK-835
      setShow(false)
      if (esitoIscrizione.flag_attivazione == 1) {
        setButtonIscrizioneLabel(Constants.BUTTON_LABEL_RISULTI_ISCRITTO)
        //STALIGK-835
        esitoIscrizione.email = newEmail;
        setAlertGiaIscritto(<Alert className="alert_iscritto" color="info">{Constants.STR_GIA_ISCRITTO_BEFORE} <strong> {esitoIscrizione.email} </strong> {Constants.STR_GIA_ISCRITTO_AFTER}</Alert>);
        setNewEmail("")
        setLabelAttiva(Constants.LABEL_RIMUOVITI_DAL_SERVIZIO)
        setMostraEsitoAggiornamentoAvvisi(true)
      } else {
        setButtonIscrizioneLabel(Constants.BUTTON_LABEL_ISCRIVITI_AL_SERVIZIO)
        //STALIGK-835
        setAlertGiaIscritto("");
        setLabelAttiva(Constants.LABEL_ISCRIVITI_AL_SERVIZIO)
        setMostraEsitoAggiornamentoAvvisi(true)
      }
    } else {
      setEsito(esitoIscrizione)
      setMostraEsitoAggiornamentoAvvisi(true)
    }
    setLoadingIscrizione(false)
  }

  if (isLoading) { return showProgress() }
  if (veicoliAttivi.length > 0) {
    return (
      <Container className="px-2 my-2" id="veicoliAttivi1" tag="section">
        <Alert color="warning" >
          ATTENZIONE: &egrave; possibile visualizzare i veicoli posseduti negli ultimi {Constants.CINQUE_ANNI} anni <br/>
          'I dati riguardanti i pagamenti sono da considerarsi a “scopo illustrativo” in quanto passibili di variazione, pertanto gli stessi non possono costituire certificazione di avvenuto pagamento'
        </Alert>
        {mostraEsitoAggiornamentoAvvisi ? showResult() : <div></div>}
        <table className="table table-striped table-sm">
          <thead className="thead-light">
            <tr>
              <th className="align-middle text-center">#</th>
              <th className="align-middle text-center">Targa</th>
              <th className="align-middle text-center">Di propriet&agrave;</th>
              <th className="align-middle text-center">Visualizza</th>
            </tr>
          </thead>
          <tbody>
            {veicoliAttivi.map((veic, i) => (
              <tr key={veic.idVeicolo}>
                <td className="align-middle text-center"><strong>{++i}</strong></td>
                <td className="align-middle text-center"><strong>{veic.targa}</strong></td>
                <td className="align-middle text-center">dal {veic.dataInizioProprieta} <br />al {veic.dataFineProprieta ? veic.dataFineProprieta : '-'}</td>
                <td className="align-middle text-center">
                  <div className="btn-group btn-group-vertical">
                    <Button
                      className="btn btn-primary my-2"
                      size="xs"
                      color="primary"
                      onClick={() => handleSubmit({ veicolo: veic, choice: Constants.CONS_CHOICE_DETTAGLI_VEICOLO })}
                    > Dettagli veicolo
                    </Button>
                    <Button
                      className="btn btn-primary mb-2"
                      size="xs"
                      color={isCedutoOltreTreAnniFa(veic) ? "secondary" : "primary"}
                      onClick={() => handleSubmit({ veicolo: veic, choice: Constants.CONS_CHOICE_DETTAGLI_PAGAMENTI })}
                    > Elenco pagamenti
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {alertGiaIscritto ?
        <>{alertGiaIscritto}
          <p>{Constants.AVVISO_SCADENZA_MAIL}</p>
          <p>{Constants.AVVISO_MANCATO_RICEVIMENTO}</p>
          <br/>
        </> 
        : <></>
      }

        <Button className="btn btn-primary my-2"
          size="xs"
          color="primary"
          onClick={() => handleShowEmail()}
        > {buttonIscrizioneLabel}
        </Button>
        {
          isLoadingIscrizione ? showProgress() :
            <Container className="px-2 my-2" id="veicoliAttivi2" tag="section" >
              <Row><Col>{showIscrizioneAvvisiScadenza()}</Col></Row>
            </Container>
        }
      </Container>
    )
  } else {
    return (<Alert color="warning">Nessun veicolo di proprietà negli ultimi cinque anni trovato</Alert>)
  }
}

export default SibaTabellaVeicoliAttivi;